
const personalityParameters = {
	SadnessJoy: [ 'Sad', 'Joyful' ],
	AngerFear: [ 'Angry', 'Fearful' ],
	DisgustTrust: [ 'Disgusted', 'Trusting' ],
	NegativePositive: [ 'Negative', 'Positive' ],
	AggressivePeaceful: [ 'Aggressive', 'Peaceful' ],
	CautiousOpen: [ 'Cautious', 'Open' ],
	IntrovertExtravert: [ 'Introverted', 'Extroverted' ],
	InsecureConfident: [ 'Insecure', 'Confident' ]
};

const dialogStyles = [
	'Bubbly',
	'Formal',
	'Blunt',
	'Inquisitive',
	'Commanding',
	'Empathetic',
	'Entertaining',
	'Laid Back',
	'Long-winded',
	'Moral',
	'Mysterious',
	'Sarcastic',
	'Tenacious',
	'Villainous'
];

function calculatePrompt( persona ) {
	const name = persona.name;
	let prompt = 'You are a character named {character}. Please respond with dialog suitable for the character you are playing. Do not use emojis in responses.\n\n';

	let sections = [
		section( 'Biography', persona?.bio ),
		section( 'Motivation', persona?.motivation ),
		section( 'Dialog_Style', dialogStyle( persona ) ),
		section( 'Personality_Traits', personality( persona ) )
	].filter( v => (v) );

	prompt += sections.join("\n\n");
	prompt = prompt.replaceAll( '{character}', name );

	return prompt;
}

function section( tagName, value ) {
	if ( ! value ) {
		return '';
	}

	value = escXML( value.trim() );
	return `<${tagName}>\n${value}\n</${tagName}>`;
}

function escXML( str ) {
	str
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&apos;');
	return str;
}

function personality( persona ) {
	let out = '';

	const levels = [ 'slightly', 'moderately', 'very', 'extremely' ];
	const attribs = [];

	for ( const key in personalityParameters ) {
		const [ min, max ] = personalityParameters[key];
		const cfg = persona?.personality_config;
		const level = cfg && key in cfg ? cfg[key] : 5;

		if ( level === 5 ) {
			continue;
		}

		const sev = level > 5 ? level - 5 : 5 - level;
		const sevidx = Math.min( levels.length, sev ) - 1;
		const severity = levels[sevidx];
		const trait = level > 5 ? max : min;

		if ( level != 5 ) {
			//slightly/moderately/very/extremely <label>
			attribs.push( `${severity} ${trait}` );
		}
	}

	if ( attribs.length ) {

		if ( attribs.length > 1 ) {
			const i = attribs.length - 1;
			attribs[i] = 'and ' + attribs[i];
		}

		out = persona.name + ' is ' + attribs.join(', ');
	}

	return out;
}

function dialogStyle( persona ) {
	let dialog = `${persona.name} tends to give `;

	const style = Array.isArray( persona?.dialog_style ) ? persona.dialog_style.slice() : [];
	dialog += style.join( ', ' );

	if ( style.length ) {
		dialog += ' and ';
	}

	dialog += '20-40 word responses.';
	return dialog;
}


module.exports = {
	personalityParameters,
	dialogStyles,
	dialogStyle,
	calculatePrompt
};